import TransitionExpand from '../TransitionExpand';

export default {
  components: {
    TransitionExpand,
  },

  props: {
    modelValue: String,
    name: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      required: false
    },
    inputType: {
      type: String,
      default: "text"
    },
    autocomplete: {
      type: String,
      required: false
    },
    focusOnMount: {
      type: Boolean,
      default: false
    },
    dataMrAss: {
      type: String
    },
    v: {
      type: Object,
      default: () => ({})
    },
  },

  emits: ['update:modelValue', 'focus', 'blur'],

  data() {
    return {
      isFocused: false,
    };
  },

  computed: {
    raiseLabel() {
      if (this.isFocused) {
        return true;
      }
      return !!this.modelValue;
    },

    inputId() {
      return 'mrInput_' + this.$.uid;
    },

    combinedAttrs() {
      return {
        ...this.$attrs,
        value: this.modelValue,
        type: this.inputType,
        id: this.inputId,
        'data-mr-ass': this.dataMrAss,
        'class': { 'invalid': this.v.$error },
        autocomplete: this.autocomplete,
        disabled: this.disabled,
        name: this.name,
        onFocus: event => this.onFocus(event),
        onBlur: event => this.onBlur(event),
        onInput: event => this.update(event.target.value),
      };
    },

    text: {
      get(){
        if (!this.modelValue) {
          return undefined;
        }
        return this.modelValue;
      },

      set(val) {
        this.$emit('update:modelValue', val);
      }
    },

    inputError: function() {
      var error = null;
      if (!this.fieldErrParams) {
        return error;
      }

      if (this.fieldErrParams.minLength && !this.v.minLength && this.v.$error) {
        error = `Must be at least ${this.fieldErrParams.minLength.min} characters.`;
      } else if (this.fieldErrParams.maxLength && !this.v.maxLength && this.v.$error) {
        error = `Must be less than ${this.fieldErrParams.maxLength.max + 1} characters.`;
      } else if ((this.fieldErrParams.email && !this.v.email) || (this.fieldErrParams.TLDValidator && !this.v.TLDValidator) && this.v.$error) {
        error = `Must be a valid email.`;
      } else if (Object.hasOwnProperty.call(this.fieldErrParams, 'mrPhoneValidator') && !this.v.mrPhoneValidator && this.v.$error) {
        error = `Please enter a valid 10-digit phone number.`;
      } else if (Object.hasOwnProperty.call(this.fieldErrParams, 'passwordSameAs') && !this.v.passwordSameAs) {
        error = `Passwords do not match`;
      } else if (Object.hasOwnProperty.call(this.fieldErrParams, 'mrCardValidator') && !this.v.mrCardValidator && this.v.$error) {
        error = `Please enter valid credit card`;
      } else if (Object.hasOwnProperty.call(this.fieldErrParams, 'mrCardExpirationMMYYValidator') && !this.v.mrCardExpirationMMYYValidator && this.v.$error) {
        error = `Please enter a valid expiration date`;
      } else if (Object.hasOwnProperty.call(this.fieldErrParams, 'strongPassword') && !this.v.strongPassword && this.v.$error) {
        error = `Your password must contain a mix of upper and lower case letters, numbers, and special characters.`;
      } else if (this.fieldErrParams.required && this.v.$error) {
        error = `This field is required.`;
      }

      return error;
    },

    fieldErrParams() {
      if (!this.v.$errors) {
        return {};
      }

      return this.v.$errors.reduce((res, err) => {
        const params = err.$params;
        if (err.$validator) {
          res[err.$validator] = params;
        }
        return res;
      }, {});
    },

    inputErrors() {
      let errors = [];

      if (!Object.keys(this.fieldErrParams).length) {
        return errors;
      }

      if (this.fieldErrParams.minLength && this.v.$error) {
        errors.push(`Must be at least ${this.fieldErrParams.minLength.min} characters.`);
      }
      if (this.fieldErrParams.maxLength && this.v.$error) {
        errors.push(`Must be less than ${this.fieldErrParams.maxLength.max + 1} characters.`);
      }
      if ((this.fieldErrParams.email || this.fieldErrParams.TLDValidator) && this.v.$error) {
        errors.push(`Must be a valid email.`);
      }
      if (Object.hasOwnProperty.call(this.fieldErrParams, 'mrPhoneValidator') && this.v.$error) {
        errors.push(`Please enter a valid 10-digit phone number.`);
      }
      if (Object.hasOwnProperty.call(this.fieldErrParams, 'passwordSameAs') && this.v.$error) {
        errors.push(`Passwords do not match`);
      }
      if (Object.hasOwnProperty.call(this.fieldErrParams, 'mrCardValidator') && this.v.$error) {
        errors.push(`Please enter valid credit card`);
      }
      if (Object.hasOwnProperty.call(this.fieldErrParams, 'mrCardExpirationMMYYValidator') && this.v.$error) {
        errors.push(`Please enter a valid expiration date`);
      }
      if (Object.hasOwnProperty.call(this.fieldErrParams, 'containsUpperAndLowerCaseCharacters') && this.v.$error) {
        errors.push(`Must contain a mix of upper and lower case letters.`);
      }
      if (Object.hasOwnProperty.call(this.fieldErrParams, 'containsNumber') && this.v.$error) {
        errors.push(`Must contain a number.`);
      }
      if (Object.hasOwnProperty.call(this.fieldErrParams, 'containsSymbol') && this.v.$error) {
        errors.push(`Must contain a special character (!@#$%^&*()?][{}+_\\-=\`~).`);
      }
      if (this.fieldErrParams.required && this.v.$error && !errors.length) {
        errors.push(`This field is required.`);
      }

      return errors;
    }
  },

  mounted() {
    if (this.focusOnMount) {
      this.$refs.input.focus();
    }
  },

  methods: {
    onBlur (e) {
      this.isFocused = false;
      if (e) {
        this.$nextTick(() => this.$emit('blur', e));
      }
    },

    onFocus (e) {
      if (!this.$refs.input) {
        return;
      }

      if (!this.isFocused) {
        this.isFocused = true;
        e && this.$emit('focus', e);
      }
    },

    delayTouch($v) {
      if (!$v?.$reset) {
        return;
      }

      $v.$reset();
      clearTimeout(this.validateTimeout);
      this.validateTimeout = setTimeout(() => {
        $v.$touch();
      }, 800);
    },

    update(value) {
      this.delayTouch(this.v);
      this.$emit('update:modelValue', value);
    },

  }
};
